import styled from 'styled-components';

const ProductInfoSectionStyle = styled.div`
	--weightMarginTopBottom: var(--sp2x) 0;
	--titleMarginBottom: var(--sp2x);
	--tagsWrapMarginTopBottom: var(--sp3x) 0 var(--sp6x) 0;
	--tagMarginRight: var(--sp4x);
	--tagImageSizes: var(--sp3x);
	--skuAndBrandMarginTopBottom: var(--sp6x) 0 var(--sp8x) 0;
	--addToBagMarginLeft: var(--sp4x);

	--buttonFixWidth: var(--sp32x);
	--avocadoSize: 30%;

	.second-version {
		.flex-column {
			flex-direction: row;
			align-items: center;
			gap: var(--sp1x);
		}
	}

	.weight {
		margin: var(--weightMarginTopBottom);
	}

	.title {
		margin-bottom: var(--titleMarginBottom);
	}

	.ant-rate,
	.rated-count {
		font-size: var(--h3);
	}

	.rated-count {
		.comp-title {
			font-size: var(--h3);
		}
	}

	.add-to-bag {
		button {
			width: var(--buttonFixWidth) !important;
			height: calc(100% - 5px) !important; /** //! 5px -> box-shadow size */
			padding: unset !important;
		}

		.avocado-1 {
			left: var(--avocadoSize) !important;
		}

		.avocado-3 {
			right: var(--avocadoSize) !important;
		}
	}

	.tags-wrap {
		display: flex;
		flex-wrap: wrap;
		margin: var(--tagsWrapMarginTopBottom);
		gap: var(--tagMarginRight);

		.tag {
			display: flex;
			align-items: center;
			flex-direction: column;

			.imageCont {
				width: var(--tagImageSizes);
				padding-top: var(--tagImageSizes);
			}
		}
	}

	.out-of-stock-note {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--sp2x);
		margin: var(--sp3x) 0;

		.comp-title {
			border-left: 2px solid var(--purple);
			padding-left: var(--sp1x);
		}
	}

	.buy-product-wrap {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--sp1x);

		.action-wrap {
			display: flex;
			gap: var(--addToBagMarginLeft);
		}
	}

	.sku-and-brand-wrap {
		margin: var(--skuAndBrandMarginTopBottom);
	}

	.tabs-wrap {
		display: flex;

		.tab-label {
			width: calc(100% / 3);
			padding-top: unset;
			padding: var(--sp1-5x);
			text-align: center;
			border-bottom: 2px solid transparent;
			cursor: pointer;

			&.active {
				border-bottom: 2px solid var(--purple);
				font-weight: 500 !important;
			}
		}
	}

	.tabs-content-wrap {
		padding-top: var(--sp2x);
	}

	.tabs-wrap {
		overflow: scroll hidden;
		-ms-overflow-style: none;
		scrollbar-width: none;

		&::-webkit-scrollbar {
			display: none;
		}

		.tab-label {
			min-width: fit-content;
		}
	}

	/* //! 1440 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--tagsWrapMarginTopBottom: var(--sp3x) 0 var(--sp5x) 0;
		--skuAndBrandMarginTopBottom: var(--sp5x) 0 var(--sp7x) 0;
		--addToBagMarginLeft: var(--sp2x);

		--buttonFixWidth: var(--sp27x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--tagsWrapMarginTopBottom: var(--sp3x) 0 var(--sp5x) 0;
		--skuAndBrandMarginTopBottom: var(--sp6x) 0 var(--sp8x) 0;
		--addToBagMarginLeft: var(--sp2x);

		--buttonFixWidth: var(--sp22x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--tagsWrapMarginTopBottom: var(--sp3x) 0 var(--sp5x) 0;
		--skuAndBrandMarginTopBottom: var(--sp6x) 0 var(--sp7x) 0;
		--addToBagMarginLeft: var(--sp2x);

		--buttonFixWidth: var(--sp22x);

		.buy-product-wrap {
			&.second-version {
				align-items: unset;
				flex-direction: column;

				.action-wrap {
					margin-top: var(--sp3x);
				}
			}
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--tagsWrapMarginTopBottom: var(--sp2-5x) 0 var(--sp5x) 0;
		--skuAndBrandMarginTopBottom: var(--sp5x) 0;
		--addToBagMarginLeft: var(--sp2x);

		--buttonFixWidth: var(--sp22x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--weightMarginTopBottom: var(--sp1x) 0 var(--sp1-5x) 0;
		--titleMarginBottom: var(--sp1x);
		--tagsWrapMarginTopBottom: var(--sp2-5x) 0 var(--sp4x) 0;
		--tagMarginRight: var(--sp2x);
		--tagImageSizes: var(--sp2x);
		--skuAndBrandMarginTopBottom: var(--sp4x) 0 var(--sp6x) 0;
		--addToBagMarginLeft: var(--sp2x);
		--addToBagMarginLeft: var(--sp2x);

		--buttonFixWidth: 100%;

		.add-to-bag {
			flex: 1;
		}

		.buy-product-wrap {
			&.second-version {
				align-items: unset;
				flex-direction: column;

				.action-wrap {
					margin-top: var(--sp3x);
				}
			}
		}
	}
`;

export default ProductInfoSectionStyle;
